// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PortfolioFromJSON, } from '../models';
/**
 * Get portfolio by id
 * Get portfolio by id
 */
export function getPortfolioByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getPortfolioById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/portfolio/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            Portfolio: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = PortfolioFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            return { Portfolio: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPortfolioById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get portfolio by id
* Get portfolio by id
*/
/**
 * Use this selector to get a reference to a single Portfolio matching the id
 * @param id Id of the Portfolio
 * @returns The Portfolio object
 */
export const usePortfolioByIdSelector = (id) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    return useSelector((state) => state.entities.Portfolio[key], isEqual);
};
/**
 * Request hook for a single Portfolio. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the Portfolio
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPortfolioById = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPortfolioByIdRaw(requestParameters, customQueryConfig));
    return [
        usePortfolioByIdSelector(requestParameters.id),
        querystate,
        forceRefresh
    ];
};
export function getPortfolioById(requestParameters, requestConfig) {
    return getPortfolioByIdRaw(requestParameters, requestConfig);
}
